/**
 * CSV出力ユーティリティ
 */

export const downloadCSV = (data: any[], filename: string) => {
  if (!data || data.length === 0) {
    console.warn('CSV出力: データが空です');
    return;
  }

  // BOM付きUTF-8で出力（Excel対応）
  const BOM = '\uFEFF';

  // ヘッダー行を取得
  const headers = Object.keys(data[0]);

  // CSVデータ生成
  const csvRows = [];

  // ヘッダー行を追加
  csvRows.push(headers.join(','));

  // データ行を追加
  for (const row of data) {
    const values = headers.map(header => {
      const value = row[header];

      // null/undefinedの場合は空文字
      if (value === null || value === undefined) {
        return '';
      }

      // 文字列の場合、カンマや改行、ダブルクォートをエスケープ
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('\n') || stringValue.includes('"')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }

      return stringValue;
    });

    csvRows.push(values.join(','));
  }

  // CSV文字列を生成
  const csvString = BOM + csvRows.join('\n');

  // Blobを作成
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

  // ダウンロードリンクを作成
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // メモリ解放
  URL.revokeObjectURL(url);
};

/**
 * オブジェクト配列をCSV形式の文字列に変換
 */
export const arrayToCSV = (data: any[]): string => {
  if (!data || data.length === 0) {
    return '';
  }

  const BOM = '\uFEFF';
  const headers = Object.keys(data[0]);
  const csvRows = [];

  csvRows.push(headers.join(','));

  for (const row of data) {
    const values = headers.map(header => {
      const value = row[header];
      if (value === null || value === undefined) return '';

      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('\n') || stringValue.includes('"')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }

      return stringValue;
    });

    csvRows.push(values.join(','));
  }

  return BOM + csvRows.join('\n');
};
